import * as service from "../service";
import { store } from "../../store";

/**
 * Fetch a page of coupons the current student has redeemed.
 * Backend: GET /api/coupon/getRedeemedCoupons/getRedeemedCoupons
 */
export const GetRedeemedCouponsAPI = async (page: number = 1) => {
  const { user } = store.getState().auth as any;
  try {
    const resp = await service.call(
      "GET",
      "api/coupon/getRedeemedCoupons/getRedeemedCoupons",
      {
        user_id: user?.id,
        page,
      },
    );
    return resp;
  } catch (err) {
    console.error(`GetRedeemedCouponsAPI ${err}`);
    return { status: -1, resp: err };
  }
};

/**
 * Sync the latest redeemed coupon state (e.g. `used`) without paginating:
 * always fetches the first page so callers can merge the fresh records.
 * Backend: GET /api/coupon/getRedeemedCoupons/getRedeemedCoupons
 */
export const SyncRedeemedCouponsAPI = async () => {
  return GetRedeemedCouponsAPI(0);
};
